import StatsTabView from 'src/features/profile/stats/components/StatsTabView'

import { usePlayerContext } from '../../context/PlayerContext'

/** Route gate for `/player/:id/stats` — all logic lives in the stats feature. */
const StatsTab = () => {
  const { state } = usePlayerContext()
  return <StatsTabView playerId={state.player?.id} />
}

export default StatsTab
